import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable, of, shareReplay, tap } from 'rxjs';
import CategoryMappingType from '../models/category-mapping-type';
import { CategoryMapping } from '../models/category-mapping';
import { CategoryMappingID } from '../models/category-mapping-id';

@Injectable({
  providedIn: 'root'
})
export class CategoryMappingService {
  private cachedCareerPathList: CategoryMappingType[] | null = null;
  private careerPathList$: Observable<CategoryMappingType[]> | null = null;

  readonly API_URL = `${environment.apiUrl}/category-mappings`;

  constructor(private http: HttpClient) {}

  getCareerPathList(): Observable<CategoryMappingType[]> {
    const cacheHasPractice = this.cachedCareerPathList?.some((item) => !!item.practice);
    if (this.cachedCareerPathList && cacheHasPractice) {
      return of(this.cachedCareerPathList);
    }

    this.careerPathList$ = this.http.get<CategoryMappingType[]>(`${this.API_URL}/career-path-and-role`).pipe(
      tap((list) => {
        this.cachedCareerPathList = list;
      }),
      shareReplay(1),
      catchError((error) => {
        this.careerPathList$ = null;
        throw error;
      }),
    );
    return this.careerPathList$;
  }

  getAll(): Observable<CategoryMapping[]> {
    return this.http.get<CategoryMapping[]>(this.API_URL);
  }

  addCategoryMapping(category: CategoryMapping): Observable<CategoryMapping> {
    return this.http.post<CategoryMapping>(this.API_URL, category);
  }

  updateCategoryMapping(originalCategory: CategoryMapping, category: CategoryMapping): Observable<CategoryMapping> {
    const formData = new FormData();
    formData.append('category', new Blob([JSON.stringify(category)], { type: 'application/json' }));
    formData.append('originalCategory', new Blob([JSON.stringify(originalCategory)], { type: 'application/json' }));
    return this.http.put<CategoryMapping>(this.API_URL, formData);
  }

  deleteCategoryMapping(id: CategoryMappingID): Observable<void> {
    return this.http.delete<void>(this.API_URL, { body: id });
  }

  getCategoryMappingsByDivision(category: string, division: string): Observable<CategoryMapping> {
    const params = new HttpParams().set('category', category).set('division', division);
    return this.http.get<CategoryMapping>(`${this.API_URL}/category-by-division`,  {params});
  }
  
}
